
import { Directive, ElementRef, Renderer2, DOCUMENT, inject, input } from '@angular/core';

@Directive({
    host: { '(mouseenter)': 'onMouseEnter()', '(mouseleave)': 'onMouseLeave()' },
    selector: '[appTooltip]',
    standalone: false
})
export class tooltipDirective {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);
  private document = inject<Document>(DOCUMENT);


  readonly tooltipTitle = input<string>(undefined);
  readonly placement = input<string>('top');
  readonly delay = input<number>(100);
  tooltip: HTMLElement;
  offset = 10;

  onMouseEnter() {
    if (!this.tooltip && this.tooltipTitle() !== '') { this.show(); }
  }

  onMouseLeave() {
    if (this.tooltip) { this.hide(); }
  }

  show() {
    this.create();
    // this.setPosition();
    this.renderer.addClass(this.tooltip, 'ng-tooltip-show');
  }

  hide() {
    this.renderer.removeClass(this.tooltip, 'ng-tooltip-show');
    window.setTimeout(() => {
      this.renderer.removeChild(this.el.nativeElement, this.tooltip);
      this.tooltip = null;
    }, this.delay());
  }

  create() {
    this.tooltip = this.renderer.createElement('span');

    this.renderer.appendChild(
      this.tooltip,
      this.renderer.createText(this.tooltipTitle()) // Here is your text
    );

    this.renderer.appendChild(this.el.nativeElement, this.tooltip);

    this.renderer.addClass(this.tooltip, 'ng-tooltip');
    this.renderer.addClass(this.tooltip, `ng-tooltip-${this.placement()}`);
    const delay = this.delay();
    this.renderer.setStyle(this.tooltip, '-webkit-transition', `opacity ${delay}ms`);
    this.renderer.setStyle(this.tooltip, '-moz-transition', `opacity ${delay}ms`);
    this.renderer.setStyle(this.tooltip, '-o-transition', `opacity ${delay}ms`);
    this.renderer.setStyle(this.tooltip, 'transition', `opacity ${delay}ms`);
  }

  setPosition() {
    const hostPos = this.el.nativeElement.getBoundingClientRect();
    const tooltipPos = this.tooltip.getBoundingClientRect();

    const scrollPos = window.pageYOffset || this.document.documentElement.scrollTop || this.document.body.scrollTop || 0;

    let top, left;

    const placement = this.placement();
    if (placement === 'top') {
      top = hostPos.top - tooltipPos.height - this.offset;
      left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
    }

    if (placement === 'bottom') {
      top = hostPos.bottom + this.offset;
      left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
    }

    if (placement === 'left') {
      top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
      left = hostPos.left - tooltipPos.width - this.offset;
    }

    if (placement === 'right') {
      top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
      left = hostPos.right + this.offset;
    }

    this.renderer.setStyle(this.tooltip, 'top', `${top + scrollPos}px`);
    this.renderer.setStyle(this.tooltip, 'left', `${left}px`);
  }
}
